export default function brokerCheck(state = { healthy: false }, action) {
    if ("LOAD_USER_APPLICATION_STATE_SUCCESS" === action.type) {
        return { healthy: action.payload.brokerCheckHealthy };
    }

    return state;
}
  


// WEBPACK FOOTER //
// ./src/reducers/brokercheck.reducer.js